
export default {
  download: 'Indirmek',
}
